import apiCore from '../../utils/api-core';

export function createDetail(id, body) {
	return apiCore.post(`/api/v1/contact-details/${id}`, body);
}

export function updateDetail(id, body) {
	return apiCore.put(`/api/v1/contact-details/${id}`, body);
}

export function removeDetail(id, field) {
	return apiCore.delete(`/api/v1/contact-details/${id}/${field}`);
}

export function updateContact(id, body) {
	return apiCore.put(`/api/v1/contacts/${id}`, body);
}

export function updateContactData(id, body) {
	return apiCore.put(`/api/v1/contacts/update/${id}`, body);
}

export function updateContactDetails(id, body) {
	return apiCore.put(`/api/v3/contact/${id}/update-details`, body);
}

export function updateContactMeta(id, body) {
	return apiCore.put(`/api/v3/contact/${id}/update-meta`, body);
}

export function validateContactMobile(body) {
	return apiCore.post(`/api/v3/contact/validate-mobile`, body);
}